export * from './IconHeartInHand';
export { default as IconHeartInHand } from './IconHeartInHand';
